<script setup>
defineProps({
  className: {
    type: String,
    default: undefined,
  },
});

const route = useRoute();
</script>

<template>
  <div class="layouts-search" :class="className">
    <LayoutHeader class="layouts-search__header" />

    <slot class-name="layouts-search__view" />

    <LayoutFooter
      class="layouts-search__footer"
      :hide-mobile-footer-content="route.meta.hideMobileFooter"
    />
  </div>
</template>

<style scoped lang="scss">
.layouts-search {
  $parent: &;

  display: flex;
  flex-direction: column;

  &__header {
    position: absolute;
    top: em(20);
    right: em(64);
    left: em(64);
    z-index: 100;

    @include media-breakpoint-down(sm) {
      top: em(16);
      right: em(16);
      left: em(16);
    }
  }
}
</style>
